import { api } from '@/backoffice/redux/api/_generated/api/billing-backoffice-api.generated';

export const billingBackofficeApi = api.enhanceEndpoints({});

export const {
  useLazySewSalesExportQuery,
  useLazySewSapExportQuery,
  useLazySewInternalSapExportQuery,
  useLazySewCreditConsumptionExportQuery,
  useLazySewInternalCostCenterExportQuery,
  useLazyResalePlansExportQuery,
  useReadTenantsLatestSubscriptionsQuery,
} = billingBackofficeApi;
